module.exports = __webpack_public_path__ + "img/SKMJ_car7.20216050.jpg";